import { createSlice } from '@reduxjs/toolkit';

/**
 * 初期状态数据
 */
const initialState = {
    sitename: '中文TV',
    viewCount: 100,
}

/**
 * 建立一个单独的状态分片
 */
const websiteSlice = createSlice({
    name: 'website',
    initialState,
    reducers: {
        add(state) {
            state.viewCount++;
        },
        multiply(state, action) {
            state.viewCount *= action.payload;
        },
    },
})

/**
 * 输出状态方法
 */
export const websiteActions = websiteSlice.actions;
/**
 * 输出状态对象
 */
export default websiteSlice;
